import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{aboutData.title}</h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">{aboutData.content}</p>
        </div>
      </div>
    </section>
  );
}